import { render } from "./SelectEnv.vue?vue&type=template&id=988fa8ea&scoped=true"
import script from "./SelectEnv.vue?vue&type=script&lang=js"
export * from "./SelectEnv.vue?vue&type=script&lang=js"

import "./SelectEnv.vue?vue&type=style&index=0&id=988fa8ea&lang=scss&scoped=true"

import exportComponent from "/var/vsts_agent/_work/1505/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-988fa8ea"]])

export default __exports__
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSlideTransition,QSeparator});
